/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit LastName/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function LastName({
  children,
  viewPath = "/DesignSystem/DataVaxiomRelationshipsItem/Edit/NonPatient/Details/LastName",
  isInvalid,
  onChange
  
}) {
let editRelationFromPersonRecordLastNameValueData = fromData.useDataValue({ viewPath,
context: 'edit_relation',
path: 'from_person_record.last_name',
})
let editRelationFromPersonRecordLastNameIsValidData = fromData.useDataIsValid({ viewPath,
context: 'edit_relation',
path: 'from_person_record.last_name',
validate: fromValidate.name,
required: true,
})
let editRelationFromPersonRecordLastNameChangeData = fromData.useDataChange({ viewPath,
context: 'edit_relation',
path: 'from_person_record.last_name',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="edit_relation.from_person_record.last_name"
 validate="/Data/validate.js name"
 required={true}
 invalid={!editRelationFromPersonRecordLastNameIsValidData}
 value={editRelationFromPersonRecordLastNameValueData}
 onChange={editRelationFromPersonRecordLastNameChangeData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Last Name"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="text"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}